module.exports = __webpack_public_path__ + "img/jwdfrozen_charge_logo.8f6c4cb0.png";